import { render, staticRenderFns } from "./VendorPartnerships.vue?vue&type=template&id=8160e0d0&"
import script from "./VendorPartnerships.vue?vue&type=script&lang=js&"
export * from "./VendorPartnerships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8160e0d0')) {
      api.createRecord('8160e0d0', component.options)
    } else {
      api.reload('8160e0d0', component.options)
    }
    module.hot.accept("./VendorPartnerships.vue?vue&type=template&id=8160e0d0&", function () {
      api.rerender('8160e0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/vendor-partners/VendorPartnerships.vue"
export default component.exports